import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function DeleteConfirmation({
  onClose,
  onConfirm,
  text,
}) {
  const [submitting, setSubmitting] = useState(false);

  return (
    <Modal
      show
      onHide={onClose}
      backdrop="static"
      id="modal-delete-confirmation"
      size="small"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {text || 'Are you sure you want delete this item?'}
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={submitting}
          variant="danger"
          onClick={async () => {
            setSubmitting(true);
            await onConfirm();
            setSubmitting(false);
            onClose();
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
